import React, { useEffect, useState } from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { phoneRegex } from '../../utils/Regex';
import { getDestination } from '../../services/Destination.service';
import { getLocation } from '../../services/Location.service';
import { getUserList } from "../../services/Authentication.service";
import { createTransaction } from '../../services/transaction.service';
import { getProject } from '../../services/Project.service';

import BackIcon from '../../assets/images/back_icon.svg'
import CreateIcon from '../../assets/images/create_icon.svg'

import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/user/user.selector";
import { flows,transactionStatus ,transactionModes}  from "../../global/transactionTypes";
import { GlobalProjectTypeId}  from "../../global/transactionTypes";
import { debug } from 'util';


const MakeInternalTransaction = ({ back, statusFilter }) => {
 
  const [DestinationList, setDestionationList] = useState([]);
  const [ProjectList, setProjectList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [UserList, setuserList] = useState([]);
  const [destinationName, setDestinationName] = useState("");
  const user = useSelector(selectCurrentUser);




  const handleClose = () => {

    resetForm();
    setErrors({});
    toast.success("Successfull Added")
    back(false)
  }

  const handleDestinationChange = (event) => {
    const { value } = event.target;
    let destinationName1 = '';
    for (let i = 0; i < DestinationList.length; i++) {

      if (value == DestinationList[i].id) {

        destinationName1 = DestinationList[i].name;
        values.name = destinationName1;
        break;
      }
    }

    setDestinationName(destinationName1);
    handleChange(event);
  };


  const dispatch = useDispatch();
  useEffect(() => {
    const getDestinationList = async () => {
      try {
        const res = await getDestination("I");


        if (res?.status === 200) {

          if (res?.data) {
            setDestionationList(res.data);
          }
        } else {
          toast.error(res?.message || res?.data?.message);
        }
      } catch (error) {
        if (error?.message) {
          const msg = error?.message?.split(":")?.[1]?.trim();
          // alert(msg);
          console.error(msg);
        }
        console.log(error.message);
      }
    };

    const getProjectList = async () => {
      try {
        const res = await getProject();


        if (res?.status === 200) {

          if (res?.data) {
            setProjectList(res.data.filter(f=>f.type==GlobalProjectTypeId));
          }
        } else {
          toast.error(res?.message || res?.data?.message);
        }
      } catch (error) {
        if (error?.message) {
          const msg = error?.message?.split(":")?.[1]?.trim();
          // alert(msg);
          console.error(msg);
        }
        console.log(error.message);
      }
    };

    const getLocationList = async () => {
      try {
        const res = await getLocation();


        if (res?.status === 200) {

          if (res?.data) {
            setLocationList(res.data);
          }
        } else {
          toast.error(res?.message || res?.data?.message);
        }
      } catch (error) {
        if (error?.message) {
          const msg = error?.message?.split(":")?.[1]?.trim();
          // alert(msg);
          console.error(msg);
        }
        console.log(error.message);
      }
    };
    const getAllUserList = async () => {
      try {
        const res = await getUserList();


        if (res?.status === 200) {

          if (res?.data) {
            setuserList(res.data);
          }
        } else {
          toast.error(res?.message || res?.data?.message);
        }
      } catch (error) {
        if (error?.message) {
          const msg = error?.message?.split(":")?.[1]?.trim();
          // alert(msg);
          console.error(msg);
        }
        console.log(error.message);
      }
    };

    getDestinationList();
    getLocationList();
    getProjectList();
    getAllUserList();
  }, [dispatch]);

  // form 
  const now = new Date();
        const formattedDateTime = now.toISOString().slice(0, 16);
  const { handleBlur, handleChange, handleSubmit, values, errors, touched, resetForm, setErrors } = useFormik({
    initialValues: {
      name: "-",
      amount: "",
      projectId: statusFilter,
      destinationId: "",
      description: "-",
      transactionModeId: "Cash",
      flowId: "1",
      transactionStatusId: "1",
      userid: user.userDetail.user.id,
      transactionDate: formattedDateTime
    },
    validationSchema: Yup.object({
      amount: Yup.string()
        .max(50, "Amount must be at most 50 characters")
        .required("Amount is required"),
      projectId: Yup.string()
        .required("Project is required"),
      userid: Yup.string()
        .required("Created by user is required"),
        transactionDate: Yup.string()
        .required("Transaction date is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {

        const payload = {
          "id": "p49",
          "name": values.name,
          "amount": Number(values.amount),
          "description": values.description, 
          "transferlog":`Intenal transaction ${DestinationList.find(user=>user.id==values.userid).name}=>${DestinationList.find(user=>user.id==values.destinationId).name}` ,
          "tansactionMode": transactionModes.find(t => t.name == "Cash").id,
          "flow": flows.find(f => f.name == "Outgoing").id,
          "transactionStatus": transactionStatus.find(t => t.name == "Settled").id,
          "createdDate":  Date.UTC,
          "modifiedDate":  Date.UTC,
          "transactionDate":values.transactionDate,
          "createdBy": values.createduserid,
          "UserID": values.userid, // From
          "projectID": values.projectId,
          "locationID": "IN50",
          "destinationID": values.destinationId, // TO
          "Project": null,
          "Location": null,
          "Destination": null,
          "parentId":null,


        }
        
        const res = await createTransaction(payload)  // First transaction from to   DEBIT
        if (res?.status === 201) {
          const from = payload.UserID;
          const to = payload.destinationID;
          payload.UserID = to;
          payload.destinationID = from;
          payload.name = DestinationList.find(user=>user.id==from).name;

          payload.flow = flows.find(f => f.name == "Incoming").id;

          payload.parentId=res.data.id;
          debugger;
          res = await createTransaction(payload) // second transaction to from  Credit
        }
        if (res?.status === 201) {
          toast.success(res.data.message)
          resetForm();
          setErrors({});
          back()

        } else {
          toast.error(res?.message || res?.data?.message);
        }
      } catch (error) {
        if (error?.message) {
          const msg = error?.message?.split(":")?.[1]?.trim();
          console.error(msg)
        }
        console.log(error.message);
      }
    },
  });
  values.createduserid = user.userDetail.user.id;
  return (
    <div className='whiteFrame'>
      <div className="mb_24 displayFlex alignItem_center gap12">
        <div>
          <button
            className="emptyBtn"
            type="button"
            onClick={handleClose}
          >
            <img src={ArrowleftIcon} alt="ArrowleftIcon" />
          </button>

        </div>
        <div>
          <h5 className='fontSize20 fontWeight600 blackClr_text'> Internal Transaction</h5>
        </div>

      </div>




      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className="mb_24 col-md-6">
            <label
              className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
              htmlFor="projectId"
            >
              Project
            </label>
            <select
              className="selectMainInput"
              id="projectId"
              name="projectId"
              value={values.projectId}
              onChange={handleChange}
            >
              <option value="">Select Project</option>
              {ProjectList.map((prject, i) => (
                <option key={i} value={prject.id}>
                  {prject.name}
                </option>
              ))}
            </select>
            {errors.projectId && touched.projectId ? (
              <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                {errors.projectId}
              </p>
            ) : (
              <></>
            )}
          </div>
          <div className="mb_24 col-md-6">
            <label
              className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
              htmlFor="fn"
            >
              Amount
            </label>
            <input
              className="MainInput"
              type="text"
              placeholder="Enter Amount"
              id="amount"
              name="amount"
              value={values.amount}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {errors.amount && touched.amount ? (
              <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                {errors.amount}
              </p>
            ) : (
              <></>
            )}
          </div>
          <div className="mb_24 col-md-6">
            <label
              className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
              htmlFor="userid"
            >
              From
            </label>
            <select
              className="selectMainInput"
              id="userid"
              name="userid"
              value={values.userid}
              onChange={handleChange}
            >
              <option value="">Select user</option>
              {UserList.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>
            {errors.userid && touched.userid ? (
              <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                {errors.userid}
              </p>
            ) : (
              <></>
            )}
          </div>

          <div className="mb_24 col-md-6">
            <label
              className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
              htmlFor="projectId"
            >
              To whom
            </label>
            <select
              className="selectMainInput"
              id="destinationId"
              name="destinationId"
              value={values.destinationId}

              onChange={handleDestinationChange}
            >
              <option value="">Select Destination</option>
              {DestinationList.map((destination, i) => (
                <option key={i} value={destination.id}>
                  {destination.name}
                </option>
              ))}
            </select>
            {errors.destinationId && touched.destinationId ? (
              <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                {errors.destinationId}
              </p>
            ) : (
              <></>
            )}
          </div>
          <div className="mb_24 col-md-6">
            <label
              className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
              htmlFor="fn"
            >
              Transaction date
            </label>
            <input
              className="MainInput"
               type="date"
              placeholder="Enter transaction date"
              id="transactionDate"
              name="transactionDate"
              value={values.transactionDate}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {errors.amount && touched.amount ? (
              <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                {errors.amount}
              </p>
            ) : (
              <></>
            )}
          </div>
           {/* ========= Mobile ========= */}
          <div className="mb_24 col-md-6">
            <label
              className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
              htmlFor="mobile"
            >
              description
            </label>
            <input
              className="MainInput"
              type="text"
              placeholder="Enter description"
              id="description"
              name="description"
              value={values.description}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {errors.description && touched.description ? (
              <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                {errors.description}
              </p>
            ) : (
              <></>
            )}
          </div>

        </div>
        {/* ========= Submit Button ========= */}
        {/* <div className='justifyContent_end displayFlex'>
                    <div> */}
        <button type="submit" className="MainButton cyanSky_clr gap8">
          <img className='width20px' src={CreateIcon} alt="CreateIcon" />
          <span>Transfer {values.transactionDate} {formattedDateTime}</span>
        </button>
        {/* </div>
                </div> */}
      </form>





    </div>
  )
}

export default MakeInternalTransaction